import { Link } from 'react-router-dom'
import { IMenuItem, ISection, IMenu } from '../../../../../types/menu'
import { AdminIcon } from '../../../../../components/ui/icons/common/admin'
import { CityIcon } from '../../../../../components/ui/icons/common/city'
import { PressIcon } from '../../../../../components/ui/icons/common/pressOffice'
import { TourismIcon } from '../../../../../components/ui/icons/common/tourism'
import { SubItemMenuNav } from "../SubItemMenuNav"
import { ContactIcon } from '../../../../../components/ui/icons/common/contact'
import { SubMenu } from "../SubMenu"
import { DownloadIcon } from '../../../../../components/ui/icons/common/download'
import { ServicesIcon } from '../../../../../components/ui/icons/common/services'
import { ListIcon } from '../../../../../components/ui/icons/common/list'
import { PhoneIcon } from '../../../../../components/ui/icons/common/phone'
import { useApp } from '../../../../../context/App'

interface Props {
	itemMenu: IMenuItem
	idActual?: number
	onChange: (id: number) => void
	count: number
}

interface IIcon {
	title: string
	icon: JSX.Element
}

export function ItemMenuNav({ itemMenu, idActual, onChange }: Props) {
	const { getTenantUrl } = useApp()

	const iconList: IIcon[] = [
		{ title: 'Administração', icon: <AdminIcon /> },
		{ title: 'Cidade', icon: <CityIcon /> },
		{ title: 'Imprensa', icon: <PressIcon /> },
		{ title: 'Turismo', icon: <TourismIcon /> },
		{ title: 'Ouvidoria', icon: <ContactIcon /> },
		{ title: 'Horários do Transporte Público', icon: <CityIcon /> },
		{ title: 'Semasa', icon: <CityIcon /> },
		{ title: 'Contato', icon: <PhoneIcon /> },
		// Saúde
		{ title: 'Institucional', icon: <ServicesIcon /> },
		{ title: 'Diretorias', icon: <AdminIcon /> },
		{ title: 'Download', icon: <DownloadIcon /> },
		{ title: 'Downloads', icon: <DownloadIcon /> },
		{ title: 'Conselho Municipal de Saúde', icon: <ContactIcon /> },
		{ title: 'Relação de Prestadores', icon: <ListIcon /> },
		// Educação
		{ title: 'Unidades de ensino', icon: <CityIcon /> },
		{ title: 'Ambiente Virtual', icon: <PressIcon /> },
		{ title: 'Mídia', icon: <PressIcon /> },
		{ title: 'Publicações', icon: <PressIcon /> },
		{ title: 'Sistemas', icon: <AdminIcon /> },
		// FMEL
		{ title: 'FMEL', icon: <CityIcon /> },
		{ title: 'Programas', icon: <ListIcon /> },
		{ title: 'Eventos', icon: <TourismIcon /> },
		{ title: 'COMEL', icon: <AdminIcon /> },
		{ title: 'Lei de Incentivo', icon: <AdminIcon /> },
		{ title: 'Convocações Oficiais', icon: <PressIcon /> },
		// Município
		{ title: 'Dados do Município', icon: <CityIcon /> },
		{ title: 'Hino', icon: <PressIcon /> },
		{ title: 'Símbolos', icon: <PressIcon /> },
		{ title: 'Prefeitos', icon: <AdminIcon /> },
		{ title: 'Galeria de Prefeitos', icon: <AdminIcon /> },
		{ title: 'Ex-Prefeitos', icon: <AdminIcon /> },
		{ title: 'Feriados', icon: <ListIcon /> },
		{ title: 'Telefones Úteis', icon: <PhoneIcon /> },
	]

	const getIcon = (title: string) => {
		const titleLower = title.toLowerCase().trim();
		const found = iconList.find((item) => item.title.toLowerCase().trim() === titleLower)
		return found ? found.icon : <CityIcon />
	}

	const hasContent = (itemMenu.secoes && itemMenu.secoes.length > 0) || (itemMenu.menus && itemMenu.menus.length > 0)

	const handleAction = () => {
		if (!hasContent && itemMenu.url) {
			window.location.href = getTenantUrl(itemMenu.url)
			return
		}
		onChange(itemMenu?.cod_menu_secao || itemMenu?.cod_menu_secao_grupo || 0)
	}

	return (
		<div className="relative group cursor-default">
			<div
				onClick={handleAction}
				className="h-10 px-2.5 flex items-center gap-1.5 text-primary dark:text-on-surface-dark no-underline whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-primary/5 dark:hover:bg-white/5 rounded-lg"
			>
				<span className="[&>svg]:h-3.5 [&>svg]:fill-secondary [&>svg]:stroke-secondary flex items-center transform transition-transform group-hover:scale-110">
					{getIcon(itemMenu.titulo || 'Cidade')}
				</span>
				<span className="font-bold text-xs uppercase tracking-wider">{itemMenu.titulo}</span>
			</div>

			{/* Dropdown Menu */}
			{hasContent && (
				<div
					className="absolute top-full left-0 pt-2 z-[100] transition-all duration-300 ease-out opacity-0 translate-y-4 scale-95 pointer-events-none group-hover:opacity-100 group-hover:translate-y-0 group-hover:scale-100 group-hover:pointer-events-auto"
				>
					<div className="bg-white dark:bg-surface-dark-alt rounded-2xl p-5 shadow-2xl dark:shadow-premium-dark border border-border-default dark:border-border-default-dark flex flex-col min-w-[15rem] max-w-sm max-h-[75vh] md:max-h-[60vh] overflow-y-auto no-scrollbar">
						{itemMenu.secoes && itemMenu.secoes.map((item: ISection, index: number) => (
							<SubItemMenuNav key={index} section={item} />
						))}

						{itemMenu.menus && (
							<div className="flex flex-col gap-1">
								{itemMenu.menus?.map((item: IMenu, index: number) => {
									let itemMenuNav_link = '#'
									let isInternal = false

									if (item.link === 'noticias') { itemMenuNav_link = '/noticias'; isInternal = true; }
									else if (item.link === 'contato') { itemMenuNav_link = '/contato'; isInternal = true; }
									else if (item.link === 'localizacao') { itemMenuNav_link = '/localizacao'; isInternal = true; }
									else if (item.link === 'telefones') { itemMenuNav_link = '/telefones'; isInternal = true; }
									else if (item.ref_cod_artigo) {
										itemMenuNav_link = '/a/' + item.ref_cod_artigo
										isInternal = true
									} else if (item.ref_cod_entidade) {
										itemMenuNav_link = '/e/' + item.ref_cod_entidade
										isInternal = true
									} else if (item.link) {
										itemMenuNav_link = item.link
									}

									const target = item.nova_janela ? '_blank' : '_self'

									return (
										<div key={index}>
											{item.subMenus ? (
												<SubMenu subMenu={item} />
											) : (
												isInternal ? (
													<Link
														to={getTenantUrl(itemMenuNav_link)}
														className="no-underline text-on-surface dark:text-on-surface-dark text-[0.6875rem] font-medium transition-all duration-200 hover:text-primary dark:hover:text-secondary hover:bg-surface-alt dark:hover:bg-white/5 px-3 py-2 rounded-lg block"
													>
														• {item.titulo}
													</Link>
												) : (
													<a
														href={getTenantUrl(itemMenuNav_link)}
														target={target}
														rel={target === '_blank' ? "noreferrer" : ""}
														className="no-underline text-on-surface dark:text-on-surface-dark text-[0.6875rem] font-medium transition-all duration-200 hover:text-primary dark:hover:text-secondary hover:bg-surface-alt dark:hover:bg-white/5 px-3 py-2 rounded-lg block"
													>
														• {item.titulo}
													</a>
												)
											)}
										</div>
									)
								})}
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	)
}